import RoleHome from '../RoleHome';

export default function KitchenManagerPage() {
  return (
    <RoleHome
      title="Kitchen manager"
      description="Meal planning and full kitchen inventory control."
    />
  );
}
